import { resources } from '@/libs/acl/resources';

export default [{
    title: 'Página Principal',
    icon: 'HomeIcon',
    route: 'home',
    resource: resources.ACL
}];